<template>
  <v-div class="HighlightedText">
    <h4 class="d-sr-only">Extract found to contain search terms</h4>
    <span v-for="(section, index) in sections" :key="index">
      <!-- eslint-disable vue/no-v-html -->
      <strong
        v-if="section.matched"
        class="marker"
        v-html="section.text"
      ></strong>
      <span v-if="!section.matched" v-html="section.text"></span>
      <!-- eslint-enable vue/no-v-html -->
    </span>
  </v-div>
</template>

<script>
export default {
  name: "HighlightedText",
  props: {
    highlight: { type: Object, default: undefined },
  },
  data() {
    return {
      showAbstract: false,
    };
  },
  computed: {
    sections() {
      const { text, matchPositions } = this.highlight;

      let originStart = 0;

      return matchPositions
        .reduce((result, item) => {
          const preamble = text.substring(originStart, item.start);
          const marker = text.substring(item.start, item.end);

          result.push({ text: preamble, matched: false });

          result.push({ text: marker, matched: true });

          originStart = item.end;

          return result;
        }, [])
        .map((r) => {
          return { matched: r.matched, text: this.sanitizeHighlight(r.text) };
        });
    },
  },
  methods: {
    sanitizeHighlight(highlightText) {
      return this.$sanitize(highlightText, {
        allowedTags: ["sup", "sub", "i", "u"],
      });
    },
  },
};
</script>

<style>
.HighlightedText {
  font-weight: 300;
}

.HighlightedText .marker {
  font-weight: bold;
}
</style>
